module.exports = __webpack_public_path__ + "img/active_yz.f5d51f94.png";